import { render } from "./AssistantMascotChatMessage.vue?vue&type=template&id=68aa195f"
import script from "./AssistantMascotChatMessage.vue?vue&type=script&lang=js"
export * from "./AssistantMascotChatMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__